import script from "./RenderDocumentHtml.vue?vue&type=script&lang=js"
export * from "./RenderDocumentHtml.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__